import { RFP_STATUSES } from "@platform/types";

import type { SortModelItem } from "ag-grid-community";

export const DOCUMENT_NAMES = {
  CENSUS: "Census",
  CURRENT_PLAN_DOCUMENT: "Current Plan Document",
  RENEWAL_RATE: "Renewal Rate",
  PROVIDER_UTILIZATION_REPORT: "Provider Utilization Report",
  DENTALPPO: "Dental PPO Average Discount Exhibit",
  MPVSCE: "Monthly Premium vs Claims Exhibit",
  LTD_CLAIMS_LISTING: "Open/Closed LTD Claims Listing",
  LTD_RESERVES_EXHIBIT: "LTD Reserves Exhibit",
  CURRENT_RATES: "Current Rates",
  INCIDENT_REPORT: "Incident Report",
  WAIVER: "Waiver",
};

export const DOCUMENT_ORDER = [
  "Census",
  "Current Plan Document",
  "Current Rates",
  "Monthly Premium vs Claims Exhibit",
  "Provider Utilization Report",
  "Dental PPO Average Discount Exhibit",
  "Open/Closed LTD Claims Listing",
  "LTD Reserves Exhibit",
  "Incident Report",
  "Waiver",
  "Renewal Rate",
];

export const productDisplayNameMap = {
  std: "Short Term Disability",
  ltd: "Long Term Disability",
  basicLife: "Basic Life/AD&D",
  voluntaryLife: "Voluntary Life/AD&D",
  dental: {
    ppo: "Dental PPO",
    dhmo: "Dental DHMO",
  },
  vision: "Vision",
  accident: "Accident Insurance",
  criticalIllness: "Critical Illness Insurance",
  hospitalIndemnity: "Hospital Indemnity Insurance",
  cancer: "Cancer Insurance",
  medical: "Family Medical Leave Administration",
};

export { RFP_STATUSES };

export type RFPStatus = keyof typeof RFP_STATUSES;

export const isValidRFPStatus = (status: string | null): status is RFPStatus =>
  status !== null && status in RFP_STATUSES;

export interface RfpPageState {
  currStatus?: string[];
  tabIndex?: number;
  query?: string;
  sortModel?: SortModelItem[];
}
